import React from 'react'
import DynamicColor from '../dynamic-color'

import useDevices from '../../../hooks/useDevices'

const DynamicAction = ({ mobileProps, desktopProps, ...props }) => {
    const { isMobile } = useDevices()

    return (
        <DynamicColor {...(isMobile ? mobileProps : desktopProps)} {...props} />
    )
}

export default DynamicAction
